module.exports = __webpack_public_path__ + "img/pr-16.ceffac0f.png";